<template>
  <el-dialog title="出库" :visible.sync="dialogVisible" width="50%" :close-on-click-modal="false" top="8vh"
    @close="close">
    <el-row type="flex">
      <upload-excel-component :on-success="handleSuccess" />
      <el-button
        size="mini"
        @click="downloadTemplate"
        style="margin-left:10px"
        >下载模板</el-button
      >
    </el-row>
    <el-table :data="tableData" border style="margin-top: 20px;" max-height="500">
      <el-table-column label="国际运单号" align="center">
        <template slot-scope="scope">
          <!-- <div :style="{ color: isRepeat(scope.row) ? 'red' : '' }">{{ scope.row.conveyNumber }}</div> -->
          <el-input @blur="outConveyNumber(scope.row)" v-model="scope.row.conveyNumber" placeholder="请输入内容"></el-input>
        </template>
      </el-table-column>

      <!-- <el-table-column label="尺寸" align="center"> -->
        <!-- <template slot-scope="scope"> -->
          <!--  :readonly="!scope.row.isEdit" -->
          <!-- <el-input v-model="scope.row.channelSize" placeholder="请输入内容"></el-input> -->
        <!-- </template> -->
      <!-- </el-table-column> -->
      <el-table-column label="长" align="center" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.length"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="宽" align="center" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.width"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="高" align="center" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.height"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="重量" align="center" width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.channelWeight"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="140" align="center">
        <template slot="header">
          <el-button type="primary" size="small" @click="addTable">添加</el-button>
        </template>
        <template slot-scope="scope">
          <!-- <el-button type="primary" size="small" v-if="!scope.row.isEdit"
            @click="scope.row.isEdit = true">编辑</el-button>
          <el-button type="success" size="small" v-else-if="scope.row.isEdit"
            @click="scope.row.isEdit = false">确定</el-button> -->
          <el-button type="danger" size="small" @click="del(scope)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <span slot="footer" class="dialog-footer">
      <el-row type="flex" justify="space-between" align="middle">
        <div>共 {{ tableData.length }} 条</div>
        <div></div>
        <el-button type="primary" @click="OutofstockDetermine" :loading="loadingStatus" :disabled="isDisabled">确
          定</el-button>
      </el-row>
      <!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
    </span>
  </el-dialog>
</template>
<script>
import { ajaxPost, Baseurl } from "@/api/api/api";
import UploadExcelComponent from '@/components/UploadExcel/index.vue'

export default {
  name: "Outofstock",
  components: {
    UploadExcelComponent
  },
  data() {
    return {
      dialogVisible: false,
      tableData: [],
      formData: {
        conveyNumber: '',
        channelWeight: '',
        length: '1',
        width: '1',
        height: '1',
      },
      loadingStatus: false
    };
  },
  computed: {
    isDisabled() {
      const tempConveyNumber = this.tableData.map(item => item.conveyNumber)
      const repeatArr = new Set([...tempConveyNumber])
      if (repeatArr.size === tempConveyNumber.length) return false
      return true
    }
  },
  methods: {
    isRepeat(item) {
      const { conveyNumber } = item
      const resultArr = this.tableData.filter(key => key.conveyNumber === conveyNumber)
      return resultArr.length > 1 ? true : false
    },
    openWebSocket() {
      if (window.WebSocket) {
        this.ws = new WebSocket('ws://localhost:4397/');

        this.ws.onopen = (e) => {
          console.log("连接服务器成功");
          this.ws.send("start");
        }
        this.ws.onclose = (e) => {
          console.log("服务器关闭");
        }
        this.ws.onerror = () => {
          console.log("连接出错");
        }
        this.ws.onmessage = (e) => {
          // console.log(e.data);
          const dataStr = e.data
          this.formData.channelWeight = dataStr
        }
      }
    },
    hanldeKeyup(e) {
      // if (!this.formData.channelWeight || !this.formData.conveyNumber || !this.dialogVisible) return
      if (e.keyCode === 13) {
        // this.addTable()
        this.OutofstockDetermine()
      }
    },
    init() {
      this.dialogVisible = true;
      this.tableData = [
          {
              id: 1,
              conveyNumber: '',
              channelWeight: '',
              length: '1',
              width: '1',
              height: '1',
          }
      ];
      this.tableData = [];
      this.openWebSocket()
      window.addEventListener('keyup', this.hanldeKeyup)
    },
    close() {
      this.dialogVisible = false;
      this.loadingStatus = false
      // this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('keyup', this.hanldeKeyup)
      // })
    },
    closeLoading() {
      this.loadingStatus = false
      this.tableData = [];
    },
    addTable() {
      this.tableData.push({
        id: 1,
        conveyNumber: '',
        channelWeight: '',
        length: '1',
        width: '1',
        height: '1',
      });
      console.log(this.tableData);
      this.formData = {
        conveyNumber: '',
        channelWeight: ''
      }
    },
    del(scope) {
      this.$confirm("您确定要删除此信息吗？", "提示")
        .then(() => {
          const itemIndex = scope.$index
          this.tableData.splice(itemIndex, 1)
        })
        .catch(() => {
          this.$message.info("取消操作");
        });
    },
    OutofstockDetermine() {
      const data = [];
      for (const item of this.tableData) {
        if (item.conveyNumber && item.length && item.width && item.height && item.channelWeight) {
          data.push(item);
        } else {
          this.$message.warning("请将信息填写完整");
          return;
        }
      }
      if (!data.length) {
        this.$message.error("请至少填写一项信息");
        return;
      }
      // if (!this.formData.channelWeight) {
      //   this.$message.warning('请输入重量')
      //   return
      // }
      // if (!this.formData.conveyNumber) {
      //   this.$message.warning('请输入国内运单号')
      //   return
      // }
      this.loadingStatus = true
      this.$emit("confirm", this.tableData);
    },
    outConveyNumber(row) {
      if (!row.conveyNumber || row.channelName) return;
      const API =
        Baseurl + "logisticsController/getOrderChannelByConveyNumber";
      const paramsData = {
        conveyNumber: row.conveyNumber
      };
      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data;
        if (code === 200) {
          row.channelName = data.channelName;
        } else {
          row.conveyNumber = "";
          this.$message.error(data);
        }
      });
    },
    handleSuccess({ results, header }) {
      this.tableData = results.map((item, index) => {
        return {
          id: index,
          conveyNumber: item.运单号,
          length: item.长,
          width: item.宽,
          height: item.高,
          channelWeight: item.重量
        }
      })
      // this.tableHeader = header
      console.log(results, header)
    },
    downloadTemplate() {
			const aEle = document.createElement('a')
			aEle.href =
				'https://hyxun-erp-image.oss-cn-hangzhou.aliyuncs.com/file/%E6%89%B9%E9%87%8F%E5%87%BA%E5%BA%93%E6%A8%A1%E6%9D%BF.xlsx'
			aEle.click()
			this.$message.success('正在下载...')
		},
  }
};
</script>
